const { useState, useCallback } = require("react");

export default function useSessionStorageNonString(key, initialState) {
    const serializedInitialState = JSON.stringify(initialState);
    let storageValue = initialState;
    try {
      storageValue = JSON.parse(sessionStorage.getItem(key)) ?? initialState;
    } catch {
        sessionStorage.setItem(key, serializedInitialState);
    }
    const [value, setValue] = useState(storageValue);
    const updatedSetValue = useCallback(
      newValue => {
        const serializedNewValue = JSON.stringify(newValue);
        if (
          serializedNewValue === serializedInitialState ||
          typeof newValue === 'undefined'
        ) {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, serializedNewValue);
        }
        setValue(newValue ?? initialState);
      },
      [initialState, serializedInitialState, key]
    );
    return [value, updatedSetValue];
  }